// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"487":"4d0715ec2fa288d2","530":"1fc6f0704e3f032e"}[chunkId] + ".js";
};